import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { useLocation, useNavigate } from "react-router";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  TooltipComponent,
} from "../../../components/Component";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../../assets/constants";
import { Spinner } from "reactstrap";
import useLogout from "../../../hooks/useLogout";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import LogoDark from "../../../images/logo.png";
import { cancelOrderApi, getOrdersDetailsAPI, labOrderListDetailsAPI } from "../../../api/pahrmacy";
import moment from "moment";
import CancelOrderModal from "../../../MyComp/UI/modals/CancelOrderModal";
// import { PrintInvoiceWithData } from "../../MyComp/UI/MyPrint/PrintInvoiceWithData";
import PrintInvoiceWithData from "../../../MyComp/UI/MyPrint/PrintInvoiceWithData";
import PrintLabWithData from "../../../MyComp/UI/MyPrint/PrintILabWithData";



const LabOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [data, setData] = useState(null);
  const [showPrint, setShowPrint] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [deliveryBoy, setDeliveryBoy] = useState(null);


  useEffect(() => {
    if (location?.state) {
      laborderDetails();
    }
  }, []);

  //   const laborderDetails = () => {
  //     setIsLoading(true);
  //     console.log(location?.state,"dffddh");
  //     labOrderListDetailsAPI(location?.state)
  //       .then((res) => {
  //         if (res?.data?.status === "expired") {
  //           toast.error(res.data.message);
  //           logout();
  //           return;
  //         }
  //         if (res?.data?.status === true) {
  //           const { order, orderItems } = res.data.data;
  //           const ph = order?.pharmacy;
  //           console.log(order, "order");
  //           setOrders(order);
  //           setData({
  //             id: order?.id,
  //             pharmacy_name: ph?.store_name,
  //             pharmacy_gst: ph?.gst_number,
  //             pharmacy_contact: ph?.mobile,
  //             order_no: order?.orderNum,
  //             date: order?.createdAt ? moment(order.createdAt).format("DD MMM YYYY, hh:mm A") : "",
  //             order_status: order?.status,
  //             subtotal: order?.orderAmount || 0,
  //             tax: 0,
  //             discount: order?.discountAmount || 0,
  //             shipping_cost: 0,
  //             total_amount: order?.totalAmount || 0,
  //             remark: order?.remark || "",
  //             address: {
  //               full_name: order?.address?.name || "",
  //               mobile: order?.address?.mobile || "",
  //               address: order?.patient.address?.addressLine1 || "",
  //               city: order?.address?.city || "",
  //               state: order?.address?.state || "",
  //               country: "India",
  //               postal_code: order?.address?.postalCode || "",
  //             },
  //             items:
  //               orderItems?.map((item) => ({
  //                 product_name: item?.medicineName || "",
  //                 unit_price: item?.price || 0,
  //                 quantity: item?.quantity || 0,
  //                 total: ((item?.price || 0) * (item?.quantity || 0)).toFixed(2),
  //               })) || [],
  //           });
  //         } else {
  //           toast.error(res?.data?.message || "Failed to load order");
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Order details error", err);
  //         toast.error("Something went wrong");
  //       })
  //       .finally(() => {
  //         setIsLoading(false);
  //       });
  //   };
  const DeliveryBoyCard = ({ deliveryBoy }) => {
    if (!deliveryBoy) return null;

    return (
      <div className="card mb-4 border-0 shadow-sm bg-light">
        <div className="card-body">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 m-0 p-0">
              {/* <div className="avatar avatar-xl rounded-circle bg-primary d-flex align-items-start justify-content-center text-white">
  <Icon name="user" className="fs-4"></Icon>
</div> */}
            </div>
            <div className="flex-grow-1 ms-3">
              <div className="row">
                <div className="col-md-8">
                  <h5 className="mb-2"><Icon name="user" className="fs-4"></Icon>{deliveryBoy.name}</h5>
                  <div className="d-flex flex-wrap gap-3">
                    <p className="mb-1 text-muted">
                      <Icon name="call" className="me-1"></Icon>
                      {deliveryBoy.mobile}
                    </p>

                  </div>
                  <div>   <p className="mb-1 text-muted mt-1">
                    <Icon name="email" className="me-1"></Icon>
                    {deliveryBoy.email}
                  </p></div>
                </div>
                <div className="col-md-4 text-md-end mt-3 mt-md-0">
                  <span className="badge bg-success px-1 py-1">
                    <Icon name="check-circle" className="me-1"></Icon>
                    {deliveryBoy.status ? "Active" : "Inactive"}
                  </span>
                  <p className="mt-2 mb-0 small text-muted">
                    <Icon name="clock" className="me-1"></Icon>
                    Joined: {moment(deliveryBoy.createdAt).format('DD MMM YYYY')}
                  </p>
                </div>
              </div>
              <div className="mt-3">
                <Button color="primary" size="sm" className="me-2">
                  <Icon name="call"></Icon> Call
                </Button>
                {/* <Button color="info" size="sm" outline>
                <Icon name="message"></Icon> Message
              </Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const laborderDetails = () => {
    setIsLoading(true);

    labOrderListDetailsAPI(location?.state)
      .then((res) => {
        if (res?.data?.status === "expired") {
          toast.error(res.data.message);
          logout();
          return;
        }

        if (res?.data?.status === true) {
          const { order, orderItems } = res.data.data;

          setDeliveryBoy(order?.deliveryBoy);
          setOrders(order);

          setData({
            id: order?.id || "",
            order_no: order?.orderNum || "",
            date: order?.createdAt
              ? moment(order.createdAt).format("DD MMM YYYY, hh:mm A")
              : "",
            order_status: order?.status || "",

            subtotal: Number(order?.orderAmount || 0),
            discount: Number(order?.discountAmount || 0),
            tax: 0,
            shipping_cost: 0,
            total_amount: Number(order?.finalAmount || 0),
            remark: order?.remark || "",

            address: {
              full_name: order?.patient?.patient_name || "",
              mobile: order?.patient?.mobile || "",
              address: order?.patient?.address || "",
              city: "", // not provided in API
              state: "",
              country: "India",
              postal_code: order?.patient?.pincode || "",
            },

            items:
              orderItems?.map((item) => ({
                product_name: item?.labTestName || "",
                group: item?.group || "",
                subgroup: item?.subgroup || "",
                unit_price: Number(item?.price || 0),

                total: Number(item?.price || 0).toFixed(2),
              })) || [],
          });
        } else {
          toast.error(res?.data?.message || "Failed to load order");
        }
      })
      .catch((err) => {
        console.error("Order details error", err);
        toast.error("Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  if (isLoading) {
    return (
      <Content>
        <div className="text-center mt-5">
          <Spinner color="primary" />
        </div>
      </Content>
    );
  }
  console.log(selectedRow, "setSelectedRow");
  const toggleCancelOrder = (item) => {
    setSelectedRow(item);

    setShowModal((pre) => !pre);
    console.log(item, "item");
  };
  const handleCancelOrder = (reason) => {
    if (!selectedRow) return;
    const payload = {
      orderId: orders?.id,

      remark: reason,
      mobile: selectedRow?.address?.mobile,
    };

    cancelOrderApi(payload)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setShowModal(false);
          navigate(-1);
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  if (!data) return null;

  return (
    <>
      <Head title="Order Details" />
      <Content>
        {/* HEADER */}
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>
                {/* Invoice <strong className="text-primary small">#{data.order_no}</strong> */}
              </BlockTitle>
              <BlockDes className="text-soft">
                Created At: <span className="text-base">{data.date}</span>
              </BlockDes>
            </BlockHeadContent>

            <BlockHeadContent>
              <Button color="primary" outline onClick={() => navigate(-1)}>
                <Icon name="arrow-left" />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {deliveryBoy && (
          <Block>
            <div className="mb-3">
              <h5 className="d-flex align-items-center">
                <Icon name="truck" className="me-2"></Icon>
                Sample Collection Person
              </h5>
            </div>
            <DeliveryBoyCard deliveryBoy={deliveryBoy} />
          </Block>
        )}

        {/* INVOICE */}
        <Block>
          <div className="invoice ">
            <div className="mt-5 invoice-action">
              {/* <Link to={`/invoice-print?order-id=${orders.id}&user-id=${orders?.userId}`} target="_blank">
                <Button size="lg" color="primary" outline className="btn-icon btn-white btn-dim">
                  <Icon name="printer-fill" />
                </Button>
              </Link> */}
              {/* <Button
              size="lg"
              color="primary"
              outline
              className="btn-icon btn-white btn-dim"
              onClick={() => setShowPrint(true)}
            >
              <Icon name="printer-fill" />
            </Button> */}

              {showPrint && (
                <PrintLabWithData
                  orderId={orders.id}
                  userId={orders.userId}
                  onDone={() => setShowPrint(false)}
                />

              )}
            </div>
            {data?.order_status == "processing" ? (
              <div className="invoice-action">
                <Button
                  size="sm"
                  color="primary"
                  outline
                  className="btn-icon btn-white btn-dim px-1"
                  onClick={() => toggleCancelOrder(data)}
                  id={"cancel-order"}
                >
                  Cancel Order
                </Button>
                {/* <TooltipComponent iconClass="card-hint" direction="top" id={`cancel-order`} text="Cancel Order" /> */}
              </div>
            ) : (
              ""
            )}

            <div className="invoice-wrap">
              <div className="invoice-brand text-center">
                <img src={LogoDark} alt="logo" />
              </div>

              <div className="invoice-head">
                <div className="invoice-contact">
                  <span className="overline-title">PATIENT NAME</span>
                  <div className="invoice-contact-info">
                    <h4 className="title">{data.address.full_name}</h4>
                    <ul className="list-plain">
                      <li>
                        <Icon name="map-pin-fill" />
                        <span>
                          {data.address.address}
                          <br />
                          {data.address.city}, {data.address.state}, {data.address.country} {data.address.postal_code}
                        </span>
                      </li>
                      <li>
                        <Icon name="call-fill" />
                        <span>{data.address.mobile}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="invoice-desc">
                  {/* <h3 className="title">Invoice</h3> */}
                  <ul className="list-plain">
                    <li>
                      <span>ORDER ID</span>: {data.order_no}
                    </li>
                    <li>
                      <span>Date</span>: {data.date.split(",")[0]}
                    </li>
                    <li>
                      {/* <span>Pharmacy</span>: {data.pharmacy_name} */}
                    </li>
                    <li>
                      {/* <span>GST</span>: {data.pharmacy_gst} */}
                    </li>
                    <li>
                      {/* <span>Contact</span>: {data.pharmacy_contact} */}
                    </li>
                  </ul>
                </div>
              </div>

              {/* ITEMS */}
              <div className="invoice-bills">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>

                        <th>Item</th>
                        <th colSpan={3}>Price</th>

                        {/* <th>Amount</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {data.items.map((item, idx) => (
                        <tr key={idx}>
                          {console.log(item, "itev")}


                          <td>{item.product_name}</td>
                          <td colSpan={3} style={{ textAlign: "right" }}>
                            {RUPEES_SYMBOL}
                            {item.unit_price}
                          </td>

                          {/* <td>
                            {RUPEES_SYMBOL}
                            {item.total}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>

                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>Subtotal</td>
                        <td>
                          {RUPEES_SYMBOL}
                          {Number(data?.subtotal || 0).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>Discount</td>
                        <td>{data.discount}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <strong>Grand Total</strong>
                        </td>
                        <td>

                          <strong>
                            {RUPEES_SYMBOL}
                            {data.total_amount}
                          </strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
      <CancelOrderModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={handleCancelOrder}
        item={selectedRow}
      />

    </>
  );
};

export default LabOrder;
